import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef, DialogService } from '@ngneat/dialog';

@Component({
  selector: 'app-modal-promotion-forbidden',
  templateUrl: './modal-promotion-forbidden.component.html',
  styleUrls: ['./modal-promotion-forbidden.component.scss']
})
export class ModalPromotionForbiddenComponent implements OnInit {

  constructor(private router: Router, private dialog: DialogService, public ref: DialogRef) { }

  ngOnInit(): void { }

  signIn() {
    this.router.navigate(['/signin']);
    this.closeModal();
    this.dialog.closeAll();
  }

  closeModal() {
    this.ref.close();
  }
}
